import { css, cx, etiColors } from '@eti/styles';
import { Children, isValidElement, cloneElement, createContext } from 'react';
import Icon from '../icon/Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const RadioGroupContext = /*#__PURE__*/createContext(null);
const RadioGroup = ({
  name,
  selectedValue,
  onChange,
  children,
  Component = 'div',
  ...rest
}) => {
  return /*#__PURE__*/_jsx(RadioGroupContext.Provider, {
    value: {
      radioGroup: {
        name,
        selectedValue,
        onChange: onChange !== null && onChange !== void 0 ? onChange : () => undefined
      }
    },
    children: /*#__PURE__*/_jsx(Component, {
      role: "radiogroup",
      ...rest,
      children: children
    })
  });
};
const getDirection = layout => {
  const direction = {
    horizontal: 'row',
    vertical: 'column'
  };
  return direction[layout !== null && layout !== void 0 ? layout : ''] || 'initial';
};
const radioGroupStyles = layout => css`
  display: ${layout ? 'flex' : 'block'};
  flex-flow: ${getDirection(layout)} wrap;
`;
const radioGroupLegendStyles = css`
  color: ${etiColors.grayScale[10]};
  font-size: 0.75rem;
  margin-bottom: 0.625rem;
`;
const errorMessageStyles = css`
  align-items: center;
  color: ${etiColors.critical.solid};
  display: flex;
  font-size: 0.875rem;
  margin-top: 0.375rem;
`;
const iconClassName = css`
  fill: ${etiColors.critical.solid};
  height: 15px;
  margin: 0 0.5rem;
  width: 15px;

  [dir='rtl'] & {
    margin-left: 0;
    margin-right: 0.5rem;
  }
`;
export const srOnly = css`
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;
const renderChildren = (children, isNeutral, layout, size) => Children.map(children, child => {
  if (! /*#__PURE__*/isValidElement(child)) {
    return child;
  }
  return /*#__PURE__*/cloneElement(child, {
    className: cx(layout && css`
              &:not(:last-child) {
                margin-bottom: ${layout === 'vertical' ? '1.25rem' : 'auto'};
                margin-right: ${layout === 'horizontal' ? '1.25rem' : 'auto'};

                html[dir='rtl'] & {
                  margin-left: ${layout === 'horizontal' ? '2rem' : 'auto'};
                  margin-right: 0;
                }
              }
            `, child.props.className),
    isNeutral,
    size
  });
});
const fieldsetStyles = css`
  border: 0;
  display: flex;
  flex-flow: row wrap;

  div[role='radiogroup'] {
    display: flex;
    width: 100%;
  }
`;
const EtiRadioGroup = ({
  children,
  className,
  dataTestId,
  errorMessage,
  isErrorDisplayed = true,
  isNeutral,
  label,
  layout,
  name,
  onChange,
  selectedValue,
  size,
  legend
}) => /*#__PURE__*/_jsxs("fieldset", {
  className: cx(fieldsetStyles, className),
  "data-testid": dataTestId,
  children: [label && /*#__PURE__*/_jsx("legend", {
    className: cx('etiRadioGroupLabel', radioGroupLegendStyles),
    children: label
  }), /*#__PURE__*/_jsx("legend", {
    className: cx('etiRadioGroupLabel', radioGroupLegendStyles, srOnly),
    children: legend
  }), errorMessage && isErrorDisplayed && /*#__PURE__*/_jsxs("span", {
    className: errorMessageStyles,
    children: [/*#__PURE__*/_jsx(Icon, {
      className: iconClassName,
      id: "circle-error"
    }), errorMessage]
  }), /*#__PURE__*/_jsx(RadioGroup, {
    className: cx('etiRadioGroup', radioGroupStyles(layout)),
    layout: layout,
    name: name,
    onChange: onChange,
    selectedValue: selectedValue,
    children: renderChildren(children, isNeutral, layout, size)
  })]
});
export default EtiRadioGroup;
//# sourceMappingURL=RadioGroup.js.map